import { Component, HostListener } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { ToasterConfig } from 'angular2-toaster';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'mercury-ui';
  isIframe = false;

  constructor(private msalService: MsalService){
    this.isIframe = window !== window.parent && !window.opener;
  }

  @HostListener('window:unload', [ '$event' ])
  unloadHandler() {
    this.msalService.logout();
  }


  public toasterconfig: ToasterConfig = new ToasterConfig({
    positionClass: 'toast-bottom-left',
    newestOnTop: false,
    preventDuplicates: true,
    limit: 3,
    timeout: { success: 5000, error: 5000 },
    showCloseButton: false,
    tapToDismiss: true
});
}
